import * as HighCharts from 'highcharts';
import HighChartsWrapper from 'highcharts-react-official';
import * as HighChartsMap from 'highcharts/highmaps';
import highchartsAccessibility from 'highcharts/modules/accessibility';
highchartsAccessibility(HighCharts);
highchartsAccessibility(HighChartsMap);
export { HighCharts, HighChartsMap, HighChartsWrapper };
